import { useSuspenseQuery } from "@apollo/client";

import { MapEditorObservationPanelObservationReadOnlyDocument } from "./queries.generated";

export function useSuspenseObservationReadOnlyQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorObservationPanelObservationReadOnlyDocument, {
        variables: { mapEditorFeatureId },
    });
}
